class IdNameDTO {
    constructor(id, name) {
        this.id = id;
        this.name = name;
    }
}

export default IdNameDTO;